export var componentsLocales = {
  closeButtonAriaLabel: 'Close modal window'
};